import React from 'react';
import { Container, Grid, Paper, Typography, Skeleton } from '@mui/material';

import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

import PseudoFileUploadPanel from './PseudoFileUploadPanel';
import DePseudoFileUploadPanel from './DePseudoFileUploadPanel';
import PseudoAnonymizerHelp from './PseudoAnonymizerHelp';

const PseudoAnonymizerPage = () => {
  const { isLoggedIn, user, isLoading } = useAuth();
  const { t } = useTranslation();

  const renderSkeleton = () => (
    <>
      <Sidebar user={user} />
      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Skeleton variant="text" width={260} height={50} />
          <Skeleton variant="text" width={520} height={32} sx={{ mb: 3 }} />

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Skeleton variant="rectangular" height={320} sx={{ borderRadius: 2 }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Skeleton variant="rectangular" height={320} sx={{ borderRadius: 2 }} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );

  if (!isLoggedIn || isLoading) return renderSkeleton();

  return (
    <>
      <Sidebar user={user} />

      <Container maxWidth="xl">
        <Paper 
          elevation={0} 
          sx={{ 
            p: { xs: 2, md: 4 }, 
            mt: 4, 
            mb: 5, 
            borderRadius: 3, 
            border: '1px solid', 
            borderColor: 'divider', 
            bgcolor: 'background.paper' 
          }}
        >
          <Grid container spacing={3}>
            {/* Header Section */}
            <Grid item xs={12}>
              <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
                {t('PseudoAnonymizerPage.title', 'Pseudonymizácia DOCX')}
              </Typography>

              <Typography variant="subtitle1" color="text.secondary">
                {t(
                  'PseudoAnonymizerPage.subtitle',
                  'Nahráte .docx súbor, vrátime pseudonymizovaný .docx a uložíme mapovanie do vaultu pre de-pseudonymizáciu.'
                )}
              </Typography>
            </Grid>

            {/* Help Section */}
            <Grid item xs={12}>
              <PseudoAnonymizerHelp t={t} />
            </Grid>

            {/* Split Screen Panels */}
            <Grid item xs={12} md={6}>
              <PseudoFileUploadPanel />
            </Grid>

            <Grid item xs={12} md={6}>
              <DePseudoFileUploadPanel />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default PseudoAnonymizerPage;